import React from 'react'
import css from './banner.module.scss'
import { History } from 'history'
import { withRouter } from 'react-router'
import leftImg from './leftImg.svg'
import rightImg from './rightImg.svg'

const MATHS_GSCE_FEBRUARY_DETAIL = '/maths-gsce-february?utm_source=homepage&utm_medium=banner&utm_campaign=february_2023'
const MATHS_GSCE_FEBRUARY = '/maths-gsce-february'

function Banner({ history }: { history: History }) {
  return (
    <div className={css.wrapper} onClick={() => {
      history.push(MATHS_GSCE_FEBRUARY_DETAIL)
    }}>
      <img src={leftImg} className={css.leftImg} />
      <div>
        <span className={css.text}>
          Check out our February GCSE Maths Accelerator course for year 11s!
        </span>
        <span className={css.chip} onClick={(evt) => {
          evt.stopPropagation()
          history.push(MATHS_GSCE_FEBRUARY)
        }}>
          CLICK HERE!
        </span>
      </div>
      <img src={rightImg} className={css.rightImg} />
    </div>
  )
}

export default withRouter(Banner)
